import { isNotEmpty, isNotEmptyOrZero } from "./Check";

export const excludeOne = <T>(entity: T, exclude: keyof T): T => {
  console.log("exclude", exclude);

  const { [exclude]: _, ...rest } = entity;
  return rest as T;
};

export const excludeMany = <T>(entity: T[], exclude: keyof T): T[] => {
  return entity.map((item) => {
    const { [exclude]: _, ...rest } = item;
    return rest;
  }) as T[];
};
export const excludeEmpty = <T>(entity: any): T => {
  const keys = Object.keys(entity);
  const filteredKeys = keys.filter(
    (key) => isNotEmpty(entity[key]) || entity[key]?.toString() == "false"
  );
  let result: any = {};
  filteredKeys.forEach((key) => {
    result[key] = entity[key];
  });
  return Object.keys(result).length > 0 ? result : (null as any);
};
export const excludeEmptyNotZero = <T>(entity: any): T => {
  const keys = Object.keys(entity);
  const filteredKeys = keys.filter(
    (key) => isNotEmptyOrZero(entity[key]) || entity[key]?.toString() == "false"
  );
  let result: any = {};
  filteredKeys.forEach((key) => {
    result[key] = entity[key];
  });
  return Object.keys(result).length > 0 ? result : (null as any);
};

export const isNotEmptyAllProperties = (entity: any) => {
  const keys = Object.keys(entity);
  return keys.length > 0 && keys.every((key) => isNotEmpty(entity[key]));
};

export const isNotEmptyOrZeroAllProperties = (entity: any) => {
  const keys = Object.keys(entity);
  return keys.length > 0 && keys.every((key) => isNotEmptyOrZero(entity[key]));
};
